import React from 'react';
import { Spin } from 'antd';
import './styles.css';

const RouteLoader: React.FC = () => {
  return (
    <div className="route-loader">
      <Spin size="large" />
      <div className="route-loader__text">Загрузка...</div>
    </div>
  );
};

export default RouteLoader;
